module.exports = __webpack_public_path__ + "static/media/icon_angle-left.136c8e4e.svg";